module.exports = __webpack_public_path__ + "img/circle1-1.c68ec803.png";